/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pin': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M8.225 5.225A11.013 11.013 0 0115.999 2a11.013 11.013 0 0111 11c0 9.412-10 16.521-10.425 16.819a1.003 1.003 0 01-1.149 0c-.426-.298-10.426-7.407-10.426-16.82a11.013 11.013 0 013.226-7.774zm9.997 4.45a4 4 0 10-4.444 6.651 4 4 0 004.444-6.652z" _fill="#0B2C62"/>'
  }
})
